import { Orders } from '../../../../app/models/orders';
import { v4 as uuid } from 'uuid';
import { store } from '../../../../app/stores/store';
import { initialOrderReceiving } from '../../../../app/models/itemOrderReceiving';
import { Activity } from '../../../../app/models/activity';
import sendRespectiveEmail from '../../../../app/models/EmailNew';
import agent from '../../../../app/api/agent';
import { toast } from 'react-toastify';
import { Dispatch, SetStateAction } from 'react';
import {
  historyPayloadType,
  updateHistoryMain,
} from '../../../../app/models/history';

async function CreateOrderReceivingSave(
  orderState: Orders,
  itemLevel: Activity,
  TemplateData: any,
  currenTaskData: string,
  currentSubTaskData: string,
  sectionModel?: string,
  setIsTableUpdated?: Dispatch<SetStateAction<boolean>>,
  closeForm?: () => void,
  setLoading?: Dispatch<SetStateAction<boolean>>,
) {
  const updateData = {
    ...orderState,
    orderId: uuid(),
    orderDateTime: store.activityStore.updateDateTime(),
    isReceiving: true,
    isDelivery: false,
    isReturn: false,
    username:
      store.userStore.user?.username !== undefined
        ? store.userStore.user.username
        : '',
    isActive: true,
    itemOrderReceiving: [
      {
        ...initialOrderReceiving,
        id: uuid(),
        receivingId: itemLevel.id,
        isActive: true,
        customerId: orderState.customerId,
        departmentId: orderState.departmentId,
        receivingWorkflows: [TemplateData],
      },
    ],
  };

  const ActArr = {
    ...itemLevel,
    movementdate: new Date().toISOString(),
    asset_tracking_status: 'Receiving Order Created',
    current_task: currenTaskData,
    current_subtask: currentSubTaskData,
    departmentId: orderState.departmentId,
    departmentName: store.activityStore.createOrderDepartmentName,
    assignedUsers: [],
    files: [],
    isReceiving: true,
    isDelivery: false,
    orders: [updateData],
  };

  const p1 = new Promise(async (resolve) => {
    await agent.Order.createOrder(ActArr).then((Response) => {
      if (sectionModel) {
        setIsTableUpdated?.(true);
        closeForm?.();
        setLoading?.(false);
      }
      setTimeout(async () => {
        if (Response.data?.includes('Order Created Successfully')) {
          if (sectionModel) toast.success('Order Created Successfully');
          if (sectionModel) return;
          store.viewStore.getItemDetails({ itemId: ActArr.id });
          await store.viewStore.getActiveOrder({ itemId: ActArr.id });
          await agent.Reschedule.updateCreateOrder(
            store.activityStore.selectedActivity?.id,
            TemplateData.templateId,
          );
        }
        resolve('');
      }, 500);
    });
  });
  p1.then(() => {
    if (sectionModel) return;
    setTimeout(async () => {
      store.activityStore.activityRegistry.delete(ActArr.id);
      // await agent.Reports.postItemIDCreateOrderReceiving(ActArr.id);
      sendRespectiveEmail(
        'Notification',
        ActArr.title,
        'Created  Assign activities Receiving Record',
        '',
        `${ActArr.type} is activities assigned successfully on`,
      );
      if (sectionModel) return;
      const payload: historyPayloadType = {
        taskId: '',
        taskName: '',
        subTaskId: '',
        subTaskName: '',
        status: `Created Order Receiving for`,
        date: new Date(),
      };
      updateHistoryMain(payload, false);
      store?.activityStore?.loadCRPagination(
        store.dashboardStore.dashboard.setCRTablePageNumber,
      );
      await store.viewStore.getActiveOrder({ itemId: ActArr.id });
      toast.success('Activities assigned Succesfully.');
      store.mediaAssetStore.mediaAsset.isViewPageCreaterLoading = false;
      store.mediaAssetStore.mediaAsset.isViewPageCreaterModalOpen = false;
    }, 1000);
  });
}

export default CreateOrderReceivingSave;
